import React, { useState } from "react";
import { Card, Form, Input, Button, message, Typography } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import { login } from "../services/api";
import SiteFooter from "../components/SiteFooter";
import PagePicture from "../components/PagePicture";

const { Title } = Typography;

const LoginScreen = ({ setUser }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        try {
            setLoading(true);
            const response = await login(values);
            localStorage.setItem("token", response.token);
            localStorage.setItem("user", JSON.stringify(response.user));
            setUser(response.user);
            message.success("登录成功");
            if (response.user.role === "admin") navigate("/admin");
            else navigate("/");
        } catch (error) {
            message.error(error?.error || "登录失败");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <PagePicture desktopSlot="auth_background_desktop" mobileSlot="auth_background_mobile" className="auth-page-background" alt="看屋子登录背景" />
            <Card style={{ width: 400, maxWidth: "100%" }}>
                <Title level={2} style={{ textAlign: "center", marginBottom: 4 }}>看屋子</Title>
                <div style={{ textAlign: "center", color: "#8c8c8c", marginBottom: 24 }}>房屋租住与管理服务</div>
                <Form onFinish={onFinish} size="large">
                    <Form.Item name="username" rules={[{ required: true, message: "请输入用户名" }]}>
                        <Input prefix={<UserOutlined />} placeholder="用户名" />
                    </Form.Item>
                    <Form.Item name="password" rules={[{ required: true, message: "请输入密码" }]}>
                        <Input.Password prefix={<LockOutlined />} placeholder="密码" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={loading} block>登录</Button>
                    </Form.Item>
                </Form>
                <div style={{ textAlign: "center" }}>
                    <Link to="/register">注册新账号</Link>
                </div>
            </Card>
            <SiteFooter compact />
        </div>
    );
};

export default LoginScreen;
